import { useLocation } from "react-router-dom";
import { CiBookmarkPlus } from "react-icons/ci";
import { BiMessageSquareDetail } from "react-icons/bi";
import { FaExternalLinkAlt } from "react-icons/fa";
import { AiOutlineGold } from "react-icons/ai";
import { IoDiamond } from "react-icons/io5";
import { MdOutlineBookmarkRemove } from "react-icons/md";

import { GeneralBtn, LinkBtn } from "../../General";
import JobCardWrapper from "../../../StylesWrappers/postJobsWrappers/postJobsWrapper";
import { capitalize } from "../../../utils/capitalize";
import { getToken } from "../../../utils/tokenStorage";

interface JobPostCardProps {
  initialSaveForLater?: any;
  handleJobDetails: () => void;
  position?: string;
  company?: string;
  jobType?: string;
  jobLocation?: string;
  jobEmail?: string;
  jobUrl?: string | undefined;
}

const JobPostCard = ({
  initialSaveForLater,
  handleJobDetails,
  position,
  company,
  jobType,
  jobLocation,
  jobEmail,
  jobUrl,
}: JobPostCardProps) => {
  const pathname = useLocation().pathname;

  const token = getToken();

  // Get the value after the https
  const httpsValue = (value: string | undefined) => {
    const arraylize = value?.split("https://");
    if (arraylize) {
      return arraylize[1];
    }
    return value;
  };

  // MAKE SURE THE LINK TO APPLY FOR JOB STARTS WITH https://
  const checkForHttps = (url: string | undefined) => {
    if (url?.startsWith("https://")) {
      return url;
    }
    return "https://" + url;
  };

  return (
    <JobCardWrapper>
      <header className="job__type__header">
        <p>
          {pathname.includes("engineering") ? <IoDiamond /> : <AiOutlineGold />}
          <span>
            {`${
              pathname.includes("engineering")
                ? "ENGINEERING JOBS"
                : "OTHER JOBS"
            }`}
          </span>
        </p>
        {token && (
          <GeneralBtn
            btnContent={
              pathname.includes("save-for-later") ? "Remove" : "Save for later"
            }
            handleClick={initialSaveForLater}
            icon={
              pathname.includes("save-for-later") ? (
                <MdOutlineBookmarkRemove />
              ) : (
                <CiBookmarkPlus />
              )
            }
            btnStyle="save__for__later"
            btnTextStyle="save__for__later__text"
          />
        )}
      </header>

      <summary className="job__summary">
        <div className="job__info__con">
          <p>{position}</p>
          <p>{jobLocation}</p>
          <p
            style={{
              fontWeight: 600,
              color: `${
                jobType?.includes("remote")
                  ? "green"
                  : jobType?.includes("onsite")
                  ? "red"
                  : "blue"
              }`,
            }}
          >
            {jobType ? capitalize(jobType) : null}
          </p>
        </div>

        <div className="card__footer">
          <GeneralBtn
            btnContent="Job Details"
            handleClick={handleJobDetails}
            icon={<BiMessageSquareDetail />}
            btnStyle="job__details__btn"
          />
          <div className="links__container">
            {jobEmail && (
              <LinkBtn
                linkContent={"Email HR"}
                url={`mailto: ${jobEmail}`}
                // target="_blank"
                linkBtn="link__btn__con"
                linkStyle="link__style"
                // icon={<FaExternalLinkAlt />}
              />
            )}
            {httpsValue(jobUrl) && (
              <LinkBtn
                linkContent={"Apply"}
                url={checkForHttps(jobUrl)}
                target="_blank"
                linkBtn="link__btn__con"
                linkStyle="link__style"
                icon={<FaExternalLinkAlt />}
              />
            )}
          </div>
        </div>
      </summary>
    </JobCardWrapper>
  );
};

export default JobPostCard;
